import { cn } from '@/lib/utils'

/**
 * Figma (node 118:2689): Horizontal = w-full h-px bg-border, Vertical = w-px h-full bg-border.
 * Separator is a simple 1px line using the border color token.
 */
export interface IntuiSeparatorProps {
  orientation?: 'horizontal' | 'vertical'
  label?: string
  className?: string
}

function IntuiSeparator({ orientation = 'horizontal', label, className }: IntuiSeparatorProps) {
  if (label && orientation === 'horizontal') {
    return (
      <div className={cn('flex items-center gap-3', className)} role="separator">
        <div className="flex-1 h-px bg-border" />
        <span className="text-xs text-muted-foreground">{label}</span>
        <div className="flex-1 h-px bg-border" />
      </div>
    )
  }
  return (
    <div role="separator" aria-orientation={orientation} className={cn(
      orientation === 'horizontal' ? 'h-px w-full bg-border' : 'w-px h-full bg-border self-stretch',
      className
    )} />
  )
}

export { IntuiSeparator }
